import { Component, OnInit } from '@angular/core';
import { colors } from '@app/consts'; 

@Component({
  selector: 'app-workforce-cost-visibility',
  templateUrl: './workforce-cost-visibility.component.html',
  styleUrls: ['./workforce-cost-visibility.component.scss']
})
export class WorkforceCostVisibilityComponent implements OnInit {

  chartData = {
    groupA: 40600670,
    groupB: 3647851
  }

  public chart: any;
  public colors: typeof colors = colors;

  constructor() { }
  
  public ngOnInit(): void {
    this.initChart();
  }

  public initChart(): void {
    this.chart = {
      color: ['#0071ce', '#ff5100'],
      tooltip: {
        trigger: 'item'
      },
      series: [{
        type: 'pie',
        radius: ['60%', '70%'],
        center: ['50%', '50%'],
        label: {
          show: false
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        hoverAnimation: false,
        avoidLabelOverlap: false,
        data: [
          {
            name: 'Employee',
            value: this.chartData.groupA
          },
          {
            name: 'Contingent Worker',
            value: this.chartData.groupB
          }
        ]
      }]
    };
  }

}
